import Action from '../action';
import App from '../../app';
import AppSettings from '../../app.settings';

export const REQUEST_TABLEAU_REPORTS = '@reports/REQUEST_TABLEAU_REPORTS';
export const REQUEST_TABLEAU_REPORTS_SUCCESS = `${REQUEST_TABLEAU_REPORTS}_SUCCESS`;
export const REQUEST_TABLEAU_REPORTS_FAILED = `${REQUEST_TABLEAU_REPORTS}_FAILED`;

export const CREATE_TABLEAU_USER = '@reports/CREATE_TABLEAU_USER';
export const CREATE_TABLEAU_USER_SUCCESS = `${CREATE_TABLEAU_USER}_SUCCESS`;
export const CREATE_TABLEAU_USER_FAILED = `${CREATE_TABLEAU_USER}_FAILED`;

export const REQUEST_TRUSTED_TICKET = '@reports/REQUEST_TRUSTED_TICKET';
export const REQUEST_TRUSTED_TICKET_SUCCESS = `${REQUEST_TRUSTED_TICKET}_SUCCESS`;
export const REQUEST_TRUSTED_TICKET_FAILED = `${REQUEST_TRUSTED_TICKET}_FAILED`;
export const CONSUME_TRUSTED_TICKET = '@reports/CONSUME_TRUSTED_TICKET';

export const receiveTableauReports = reportsList => Action(REQUEST_TABLEAU_REPORTS_SUCCESS, {reportsList});
export const requestTableauReportsFailed = error => Action(REQUEST_TABLEAU_REPORTS_FAILED, error, true);

export const requestTrustedTicket = username => Action(REQUEST_TRUSTED_TICKET, {username});
export const requestTrustedTicketSuccess = ticket => Action(REQUEST_TRUSTED_TICKET_SUCCESS, ticket);
export const requestTrustedTicketFailed = error => Action(REQUEST_TRUSTED_TICKET_FAILED, error, true);

export const createTableauUser = (username, email, context) => Action(CREATE_TABLEAU_USER, {username, email, context});
export const createTableauUserSuccess = username => Action(CREATE_TABLEAU_USER_SUCCESS, {username});
export const createTableauUserFailed = error => Action(CREATE_TABLEAU_USER_FAILED, error, true);

export const getTrustedTicket = username => {
  return dispatch => {

    const axios = App.getAxios();

    dispatch(requestTrustedTicket(username));

    return axios.get(`/ticket/${username}`, {baseURL: AppSettings.BaseTableauProxyUrl })
      .then(response => response.data)
      .then(data => dispatch(requestTrustedTicketSuccess(data)))
      .catch(err => dispatch(requestTrustedTicketFailed(err)));
  };
};